import React, { useRef } from 'react'
import ImageList from './ImageList'
import { useUserDashboard } from 'shared-ui/hooks'
import { useLocation } from 'react-router-dom'
import { QUERY_KEY } from 'shared-ui/utils/constants'
import { useSelector } from 'react-redux'
import { useFilterOptions } from 'shared-ui/hooks'
import { DASHBOARD_TABS } from 'shared-ui/utils/constants'

const DashboardImageList = () => {
  const location = useLocation()
  const loadMoreRef = useRef(null)
  const navigationState = location.state
  const initialContentId = navigationState?.id
  const parentLocation = navigationState?.parentLocation || ''
  const fromNotYetPublished = navigationState?.fromNotYetPublished || false
  const isUGC = location?.state?.is_UGC_state
  const isFromCreatorProfile = parentLocation.toLowerCase().includes('creator')
  const creatorId = isFromCreatorProfile ? parentLocation.split('/')[2] : null
  const fromDashboard = navigationState?.fromDashboard

  const { contentDashboardPusblishedType, filters } = useSelector(
    (state) => state.dashBoardType
  )

  const { data: filterOptions } = useFilterOptions()
 
  const getNormalizedTab = () => {
    switch (contentDashboardPusblishedType) {
      case DASHBOARD_TABS.PUBLISHED:
        return 'published'
      case DASHBOARD_TABS.NOT_YET_PUBLISHED:
        return 'not_yet_published'
      case DASHBOARD_TABS.SAVED:
        return 'saved'
      default:
        if (contentDashboardPusblishedType === 'Published') return 'published'
        if (contentDashboardPusblishedType === 'Not Yet Published')
          return 'not_yet_published'
        if (!isFromCreatorProfile && contentDashboardPusblishedType === 'Saved') return 'saved'
        return 'published'
    }
  }

  const getVerificationStatus = () => {
    if(isFromCreatorProfile) return 'approved';
    switch (contentDashboardPusblishedType) {
      case DASHBOARD_TABS.PUBLISHED:
        return 'approved'
      case DASHBOARD_TABS.NOT_YET_PUBLISHED:
        return 'pending'
      case DASHBOARD_TABS.SAVED:
        return 'saved'
      default:
        if (contentDashboardPusblishedType === 'Published') return 'approved'
        if (contentDashboardPusblishedType === 'Not Yet Published')
          return 'pending'
        if (contentDashboardPusblishedType === 'Saved') return 'saved'
        return 'approved'
    }
  }

  const normalizedTab = getNormalizedTab()
  const verificationStatus = getVerificationStatus()
  const user_id = creatorId
    ? creatorId
    : JSON.parse(localStorage.getItem('user'))?.user_id

  const {
    data: dashBoardData,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useUserDashboard(
    user_id,
    verificationStatus,
    // filters?.contentTypes || filterOptions?.data?.content_type || ['video', 'image', 'audio'],
    ['video', 'image', 'audio'],
    normalizedTab,
    filters?.sortBy || 'newest_first',
    filters?.tools || [],
  )

  const publishedItems = dashBoardData?.pages?.flatMap((page) => {
    // If we have tab-specific results in a nested structure
    if (page?.data?.[normalizedTab]?.results) {
      return page.data[normalizedTab].results
    }

    // Legacy fallbacks
    if (normalizedTab === 'published') {
      return page?.data?.data ?? []
    }

    if (normalizedTab === 'saved') {
      const savedItems =
        page?.data?.[normalizedTab]?.results ||
        (Array.isArray(page?.data) ? page.data : [])
      return savedItems ?? []
    }

    return page?.data?.[normalizedTab]?.results ?? []
  })

  // const trendingData = publishedItems?.pages?.flatMap((data) => data?.data?.trays?.[0]?.assets)

  const imageData = publishedItems?.filter(
    (asset) => (asset?.content_type || '').toLowerCase() === 'image'
  )

  return (
    <ImageList
      listData={imageData || []}
      initialContentId={initialContentId}
      parentLocation={parentLocation}
      fromNotYetPublished={fromNotYetPublished}
      isUGC={isUGC}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      loadMoreRef={loadMoreRef}
      queryKey={QUERY_KEY.GET_USER_DASHBOARD}
      fromDashboard={fromDashboard}
      initialLoading={isLoading}

    />
  )
}

export default DashboardImageList
